module.exports = __webpack_public_path__ + "static/media/fib.9c5fb97b.gif";